var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPublicDisruption = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "public-distruption-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 35,
    cy: 35,
    r: 34,
    fill: "#F2A633",
    fillOpacity: 0.5,
    stroke: "#F2A633",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_4003_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.5362 26.9552V15H23V54.8529H25.8273L36.3387 36.7104C37.1643 35.302 39.4842 35.302 40.3083 36.7104L44.6238 44.2012C44.5931 38.452 44.5654 32.7028 44.5362 26.9552ZM32.7888 40.9041H26.9158V34.9265H32.7888V40.9041ZM32.7888 32.9344H26.9158V26.9552H32.7888V32.9344ZM32.7888 24.9632H26.9158V18.984H32.7888V24.9632ZM40.6204 32.9344H34.7459V26.9552H40.6204V32.9344ZM40.6204 24.9632H34.7459V18.984H40.6204V24.9632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.8355 53.0283L39.6795 38.3925C39.1122 37.3895 37.5148 37.3895 36.946 38.3925L28.7438 53.0283C28.2349 53.9297 28.9683 55 30.1044 55H46.4734C47.611 55 48.3444 53.9297 47.8355 53.0283ZM38.2604 52.7764C37.5809 52.7764 37.0305 52.2162 37.0305 51.5245C37.0305 50.8329 37.5809 50.2727 38.2604 50.2727C38.94 50.2727 39.4904 50.8329 39.4904 51.5245C39.4904 52.2162 38.94 52.7764 38.2604 52.7764ZM39.4904 48.0819C39.4904 48.7736 38.94 49.3338 38.2604 49.3338C37.5809 49.3338 37.0305 48.7736 37.0305 48.0819V43.8569C37.0305 43.1653 37.5809 42.6051 38.2604 42.6051C38.6002 42.6051 38.9077 42.7459 39.1306 42.9712C39.352 43.1981 39.4904 43.5111 39.4904 43.8569V48.0819Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 40,
    fill: "white",
    transform: "translate(23 15)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPublicDisruption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/public_disruption.c6f4ec3ed59f397e14a1b8d977461412.svg";